import { CdkMenuModule } from '@angular/cdk/menu';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';

@Component({
  selector: 'pm-section-title',
  templateUrl: './section-title.component.html',
  imports: [TranslateModule, CdkMenuModule, InlineSVGModule],
})
export class SectionTitleComponent {
  @Input({ required: true }) title: string;
  @Input({ required: true }) isHovered: boolean;
}
